import { takeLatest } from "redux-saga/effects";
import {
	getEmployeeAssignedAssetListSuccess,
	getEmployeeAssignedAssetListFail,
	getEmployeeAssignedAssetDetailsSuccess,
	getEmployeeAssignedAssetDetailsFail,
	getAssetOptionsSuccess,
	getAssetOptionsFail,
} from "./employeeAssignedAssetState";
import createCrudService from "../../services/crudservice";
import {
	doCrudCall,
	SAVING_MSG,
	UPDATING_MSG,
	DELETING_MSG,
	LOADING_MSG,
	createRecordSuccess,
	updateRecordSuccess,
	deleteRecordSuccess,
} from "../../utils/crudSagaHelper";

const crudService = createCrudService("api/v1/console/employee-assigned-assets");
const redirectData = {
    route: "/console/employees",
    mode: "list",
    recordId: 0,
};

const modelName = "Assigned Asset";
const modelId = "eaa_id";

function* getEmployeeAssignedAssetList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload),
		getEmployeeAssignedAssetListSuccess,
		getEmployeeAssignedAssetListFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getEmployeeAssignedAssetDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload),
		getEmployeeAssignedAssetDetailsSuccess,
		getEmployeeAssignedAssetDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* doEmployeeAssignedAssetCreate(data) {
	yield doCrudCall(
		() => crudService.doCreate(data.payload),
		getEmployeeAssignedAssetDetailsSuccess,
		getEmployeeAssignedAssetDetailsFail,
		createRecordSuccess(modelName),
		{ ...redirectData, mode: "reload" },
		SAVING_MSG
	);
}

function* doEmployeeAssignedAssetUpdate(data) {
	console.log("Saga payload", data.payload);
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload),
		getEmployeeAssignedAssetDetailsSuccess,
		getEmployeeAssignedAssetDetailsFail,
		updateRecordSuccess(modelName),
		{ ...redirectData, mode: "reload" },
		UPDATING_MSG
	);
}

function* doEmployeeAssignedAssetDelete(data) {
	    console.log('payload',data.payload);

	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId),
		getEmployeeAssignedAssetDetailsSuccess,
		getEmployeeAssignedAssetDetailsFail,
		deleteRecordSuccess(modelName),
		{ ...redirectData, mode:  "reload" },
		DELETING_MSG
	);
}

function* fetchAssetOptions(data) {
    yield doCrudCall(
        () =>
            crudService.doGetRequest(
                "asset-options",
                data.payload
            ),
        getAssetOptionsSuccess,
        getAssetOptionsFail,
        null,
        null,
        LOADING_MSG
    );
}

function* employeeAssignedAssetSaga() {
	yield takeLatest("employeeAssignedAsset/getEmployeeAssignedAssetList", getEmployeeAssignedAssetList);
	yield takeLatest("employeeAssignedAsset/getEmployeeAssignedAssetDetails", getEmployeeAssignedAssetDetails);
	yield takeLatest("employeeAssignedAsset/doEmployeeAssignedAssetCreate", doEmployeeAssignedAssetCreate);
	yield takeLatest("employeeAssignedAsset/doEmployeeAssignedAssetUpdate", doEmployeeAssignedAssetUpdate);
	yield takeLatest("employeeAssignedAsset/doEmployeeAssignedAssetDelete", doEmployeeAssignedAssetDelete);
	yield takeLatest( "employeeAssignedAsset/getAssetOptions", fetchAssetOptions);
}

export default employeeAssignedAssetSaga;